import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { activateWaitingServiceWorker } from '../../pwa/register.js';

export function PwaUpdateToast() {
  const { t } = useTranslation('common');
  const [showReload, setShowReload] = useState(false);

  useEffect(() => {
    const onUpdate = () => setShowReload(true);
    window.addEventListener('nutians:pwa-update-available', onUpdate);
    return () => window.removeEventListener('nutians:pwa-update-available', onUpdate);
  }, []);

  if (!showReload) return null;

  return (
    <div className="fixed right-4 bottom-4 z-50 max-w-sm rounded-lg border border-husk bg-shell p-4 text-ink shadow-lg dark:border-husk dark:bg-shell dark:text-ink">
      <p className="text-sm font-medium">{t('pwa.update.title')}</p>
      <p className="mt-1 text-sm text-ink-soft">{t('pwa.update.body')}</p>
      <div className="mt-3 flex justify-end gap-2">
        <button
          type="button"
          onClick={() => setShowReload(false)}
          className="rounded border border-husk px-3 py-1.5 text-sm text-ink-soft hover:text-ink"
        >
          {t('dismiss')}
        </button>
        <button
          type="button"
          onClick={() => void activateWaitingServiceWorker()}
          className="rounded bg-leaf px-3 py-1.5 text-sm font-medium text-white hover:bg-leaf-deep"
        >
          {t('pwa.update.reload')}
        </button>
      </div>
    </div>
  );
}
